<template>
    <md-content class="card">
        <md-dialog-confirm :md-active.sync="confirmDeleteGroupDialog.active"
                           :md-title="$t('dialog.confirm-delete.title')"
                           :md-confirm-text="$t('dialog.confirm-delete.yes')"
                           :md-cancel-text="$t('dialog.confirm-delete.no')"
                           @md-cancel="cancelDeleteGroup" @md-confirm="deleteGroup(confirmDeleteGroupDialog.groupId)" />
        <div class="md-header-section">
            <md-content class="md-layout  md-alignment-space-around-space-between" :md-elevation="8">
                <div class="md-layout-item md-header-bg md-flex-left">
                    <conditional-router-link to="/privileges/roles">
                        <h1 class="md-header-title-inactive">{{ $t('views.admin.privileges.role.title') }}</h1>
                    </conditional-router-link>
                    <h1 class="md-header-title md-ml-15">
{{ $t('views.admin.privileges.group.list.table.groups.title')
                        }}
</h1>
                </div>
                <div class="md-flex-right-align">
                    <div class="md-search-btn" v-if="!searchExpand" @click="searchExpand = !searchExpand">
                        <md-icon>search</md-icon>
                    </div>
                    <adsign-filter v-if="searchExpand" v-model="filterValue" :filter-data-model="filterDataModel"
                                   class=""
                                   @search="searchTemplate()" />
                    <conditional-router-link to="/privileges/groups/create">
                        <md-button class="md-header-btn">{{ $t('views.admin.privileges.group.list.add') }}</md-button>
                    </conditional-router-link>
                </div>
            </md-content>
        </div>
        <md-table v-model="groups.content" :md-sort.sync="currentSort" :md-sort-order.sync="currentSortOrder"
                  :md-sort-fn="customSort">
            <md-table-row slot="md-table-row" slot-scope="{ item, index }" class="md-accent"
                          ref="groupsTable"
                          @mouseover="currentHoverIndex = index"
                          @mouseleave="currentHoverIndex = null">
                <md-table-cell :md-label="$t('views.admin.privileges.group.list.table.groups.id')">
{{ getNo(index)
                    }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.admin.privileges.group.list.table.groups.name')"
                               md-sort-by="name">
{{ item.name }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.admin.privileges.group.list.table.groups.isActive')"
                               md-sort-by="isDeleted">
{{ $t(`dialog.${!item.isDeleted}`) }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.admin.privileges.group.list.table.groups.updatedBy')"
                               md-sort-by="updatedBy">
{{ item.updatedBy }}
                </md-table-cell>
                <md-table-cell :md-label="$t('views.admin.privileges.group.list.table.groups.updatedAt')"
                               md-sort-by="updatedAt">
{{ item.updatedAt | moment('L LT') }}
                </md-table-cell>
                <div class="actions" v-if="currentHoverIndex == index">
                  <conditional-router-link :to="`groups/${item.id}`">
                    <md-button class="md-icon-button">
                      <md-tooltip md-direction="top">{{ $t('edit') }}</md-tooltip>
                      <md-icon>description</md-icon>
                    </md-button>
                  </conditional-router-link>
                  <conditional-router-link :to="`groups/view/${item.id}`">
                    <md-button class="md-icon-button">
                      <md-tooltip md-direction="top">{{ $t('view') }}</md-tooltip>
                      <md-icon>search</md-icon>
                    </md-button>
                  </conditional-router-link>
                  <meta-privilege-checker>
                    <md-button class="md-icon-button" @click="showConfirmDeleteGroup(item)">
                      <md-tooltip md-direction="top">{{ $t('delete') }}</md-tooltip>
                      <md-icon>delete</md-icon>
                    </md-button>
                  </meta-privilege-checker>
                </div>
            </md-table-row>
            <md-table-empty-state
                    v-if="!loading"
                    class="md-layout-item md-size-100"
                    :md-label="$t('dialog.noData')" />
            <Spiner :loading="loading" />        
        </md-table>
        <div class="md-layout right">
            <paginator :page.sync="currentPage" :length="groups.totalElements || 0" :page-size.sync="pageSize"
                       @pageChange="loadGroups(currentPage, pageSize, sort)" class="right" />
        </div>
    </md-content>
</template>

<script>
  import {groupsEndpoint} from '@/services/adsign-backend/endpoints';
  import {mapGetters} from 'vuex';
  import ConditionalRouterLink from '@/components/ConditionalRouterLink';
  import MetaPrivilegeChecker from '@/components/MetaPrivilegeChecker';
  import {FilterType} from '@/mixins/filterType';
  import sortSupport from '@/mixins/sortSupport';
  import Paginator from '@/components/Paginator';
  import AdsignFilter from '@/components/AdsignFilter';
  import Spiner from '@/components/Spiner'

  export default {
    name: 'GroupsList',
    mixins: [sortSupport],
    components: {Paginator, ConditionalRouterLink, AdsignFilter, MetaPrivilegeChecker, Spiner},
    data: () => ({
      confirmDeleteGroupDialog: {
        active: false,
        groupId: undefined
      },
      searchExpand: false,
      sending: false,
      currentSort: 'id',
      groups: {
        pageable: {
          pageNumber: 0,
          pageSize: 0,
          filter: null
        },
        totalElements: null,
        content: []
      },
      filterValue: '',
      filterDataModel: [
        {id: 'name', type: FilterType.String},
        {id: 'isDeleted', type: FilterType.BooleanNot},
        {id: 'updatedBy', type: FilterType.String},
        {id: 'updatedAt', type: FilterType.Date},
      ],
      loading: false,
      currentHoverIndex: null
    }),

    mounted() {
      this.loadGroups();
    },
    computed: {
      ...mapGetters('auth', ['hasAccess'])
    },
    methods: {
      customSort(value) {
        this.searchTemplate();
        return value;
      },
      loadGroups(page, pageSize, sort, filter) {
        this.loading = true;
        groupsEndpoint.getGroups(page - 1, pageSize, sort, filter)
            .then(response => this.groups = response.data)
            .catch(this.handleServerValidationError)
            .finally(() => this.loading = false)
      },
      showConfirmDeleteGroup(group) {
        this.$refs.groupsTable.MdTable.selectedItems.push(group);

        this.confirmDeleteGroupDialog.active = true;
        this.confirmDeleteGroupDialog.groupId = group.id;
      },
      deleteGroup(groupId) {
        groupsEndpoint.deleteGroup(groupId).then(result => {
          this.loadGroups();
        });
        this.$refs.groupsTable.MdTable.selectedItems = [];
      },
      cancelDeleteGroup() {
        this.$refs.groupsTable.MdTable.selectedItems = [];
      },
      showAddClientForm() {
        this.$router.push(`/groups/create`);
      },
      searchTemplate() {
        this.loadGroups(this.currentPage, this.pageSize, this.sort, this.filterValue);
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
